export const LOGIN_USER = 'LOGIN_USER'
export const LOGOUT_USER = 'LOGOUT_USER'
export const SET_USER = 'SET_USER'
export const SET_USERNAME = 'SET_USERNAME'
export const SET_CURRENT_INTRO_STEP = 'SET_CURRENT_INTRO_STEP'
